// The one official John Campbell Insurance horizontal lockup.
// Composed from the approved crest artwork + wordmark, so the gold rule sits
// cleanly BELOW the "John Campbell" wordmark (never touching the typography),
// with a tightened crest-to-wordmark gap, a slightly smaller crest, and the
// crest optically raised to align with the wordmark.
const SIZES = {
  sm: {
    crest: "h-[2.9rem]",
    gap: "gap-2.5",
    name: "text-lg",
    line: "h-px my-[5px]",
    ins: "text-[7px] tracking-[0.42em]",
    raise: "-translate-y-[7%]",
  },
  md: {
    crest: "h-12 sm:h-[3.4rem]",
    gap: "gap-2.5 sm:gap-3",
    name: "text-xl sm:text-2xl",
    line: "h-px my-[5px] sm:my-[6px]",
    ins: "text-[7px] sm:text-[8px] tracking-[0.45em] sm:tracking-[0.5em]",
    raise: "-translate-y-[7%]",
  },
  lg: {
    crest: "h-16 lg:h-[4.75rem]",
    gap: "gap-4 lg:gap-5",
    name: "text-3xl lg:text-[2.6rem]",
    line: "h-[1.5px] my-2",
    ins: "text-[10px] lg:text-[11px] tracking-[0.55em]",
    raise: "-translate-y-[6%]",
  },
};

export const BrandLogo = ({ size = "md", className = "", crestClassName = "" }) => {
  const s = SIZES[size] || SIZES.md;
  return (
    <span className={`inline-flex items-center ${s.gap} ${className}`} data-testid="brand-logo-lockup">
      <img
        src="/logo-crest.png"
        alt="John Campbell Insurance crest"
        className={`${s.crest} w-auto shrink-0 ${s.raise} drop-shadow-[0_2px_10px_rgba(212,175,55,0.25)] ${crestClassName}`}
      />
      <span className="inline-flex flex-col leading-none">
        <span className={`serif font-normal text-[#f4f0ea] leading-[1.02] ${s.name}`}>John&nbsp;Campbell</span>
        <span
          className={`block w-full ${s.line} bg-gradient-to-r from-[#d4af37] via-[#d4af37] to-[#d4af37]/30`}
          aria-hidden="true"
        />
        <span className={`mono uppercase text-[#d4af37] leading-none ${s.ins}`}>Insurance</span>
      </span>
    </span>
  );
};

export default BrandLogo;
